import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=f6bbf794&scoped=true"
import script from "./nosotros.vue?vue&type=script&lang=js"
export * from "./nosotros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bbf794",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
